module.exports = __webpack_public_path__ + "img/event-busy_outlined.477a464a.svg";